import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

const ButtonAdd = ({ data, validateAddEnterprise, routeToCancel, form }) => {

    return (
    <div className="row top-separator-xs bottom-separator-xs">
        <div className="col-xs-2">
          <GenericSimpleButton
             buttonId="updateMotivoBloqueo"
             buttonType="button"
             text="Aceptar"
             onClick={() => validateAddEnterprise(data, form)}
             buttonClass="btn btn-cta"
          />
        </div>
        <div className="col-xs-2">
          <button
             type="button"
             id="btnCancel"
             className="btn btn-secondary"
             onClick={() => routeToCancel()}
           >
           Cancelar
         </button>
        </div>
    </div>
    );

}

export default ButtonAdd;